import { fromJS } from 'immutable';

import {
  CONFIRM_APPROVE_BUILDER,
  CONFIRM_APPROVE_BUILDER_SUCCESS,
  CONFIRM_APPROVE_BUILDER_FAILURE,
} from '../actions/actionTypes';

const initialState = fromJS({
  isLoading: false,
  error: null,
  isApproved: 0,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIRM_APPROVE_BUILDER:
      return state.set('isLoading', true).set('error', null);
    case CONFIRM_APPROVE_BUILDER_SUCCESS: {
      return state
        .set('isLoading', false)
        .set('isApproved', action.isApproved)
        .set('error', null);
    }
    case CONFIRM_APPROVE_BUILDER_FAILURE:
      return state
        .set('isLoading', false)
        .set('error', fromJS({ message: action.errMsg }));
    default:
      return state;
  }
};

export default reducer;
